var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0003 16.0975L2.95109 8.04822C2.68297 7.78009 2.68297 7.34559 2.95109 7.07609C3.22059 6.80797 3.65509 6.80797 3.92459 7.07609L11.0003 14.1532L18.0761 7.07609C18.3456 6.80797 18.7801 6.80797 19.0496 7.07609C19.3177 7.34559 19.3177 7.78009 19.0496 8.04822L11.0003 16.0975Z",
    fill: "#E81111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RedArrow.82578d86206c834c40d20549207724c5.svg";